import React, { 
  // useRef, 
  // useState 
} from "react";
import { 
  // SearchOutlined 
} from "@ant-design/icons";
// import Highlighter from "react-highlight-words";
import { 
  // Button, 
  // Input, 
  // Space, 
  Table, 
  Tag 
} from "antd";
import { useNavigate } from "react-router-dom";
import { ProductOutlined } from '@ant-design/icons';

const AntDTable = ({
    tableHeaders,
    headerSelector,
    tableData,
    rowClickPath,
    isClickable,
    ActionBtn,
    withAction,
    loading,
    customFooter,
    className,
    searchExcluded = [], // headers to exclude from search feature
    pageSize,
    handleTableChange,
    filterConfig,
    totalSize,
    isSearch,
  }) => {
    const navigate = useNavigate();
    // const [searchText, setSearchText] = useState("");
    // const [searchedColumn, setSearchedColumn] = useState("");
    // const searchInput = useRef(null);
    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30" }} spin/>; // Custom spinner component
    // const paginationConfig = {
    //   pageSizeOptions: ["10", "20", "50", "100"], // Options for items per page
    //   showSizeChanger: true, // Show items per page changer
    //   // showQuickJumper: true, // Show quick jumper to navigate to a specific page
    //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Show total items text
    // };
    // const handleSearch = (selectedKeys, confirm, dataIndex) => {
    //   confirm();
    //   setSearchText(selectedKeys[0]);
    //   setSearchedColumn(dataIndex);
    // };
    // const handleReset = (clearFilters) => {
    //   clearFilters();
    //   setSearchText("");
    // };
    const handleRowClick = (record) => {
      if (isClickable) {
        const id = record.id;
        navigate(`${rowClickPath}/${id}`);
      }
    };
    // const getColumnSearchProps = (dataIndex) => {
    //   if (!searchExcluded.includes(dataIndex)) {
    //     return {
    //       filterDropdown: ({
    //         setSelectedKeys,
    //         selectedKeys,
    //         confirm,
    //         clearFilters,
    //         close,
    //       }) => (
    //         <div
    //           style={{
    //             padding: 8,
    //           }}
    //           onKeyDown={(e) => e.stopPropagation()}
    //         >
    //           <Input
    //             ref={searchInput}
    //             placeholder={`Search ${dataIndex}`}
    //             value={selectedKeys[0]}
    //             onChange={(e) =>
    //               setSelectedKeys(e.target.value ? [e.target.value] : [])
    //             }
    //             onPressEnter={() =>
    //               handleSearch(selectedKeys, confirm, dataIndex)
    //             }
    //             style={{
    //               marginBottom: 8,
    //               display: "block",
    //             }}
    //           />
    //           <Space>
    //             <Button
    //               type="primary"
    //               onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
    //               icon={<SearchOutlined />}
    //               size="small"
    //               style={{
    //                 width: 90,
    //               }}
    //               className='button-color btn-header'
    //             >
    //               Search
    //             </Button>
    //             <Button
    //               onClick={() => clearFilters && handleReset(clearFilters)}
    //               size="small"
    //               style={{
    //                 width: 90,
    //               }}
    //               className='button-color btn-header'
    //             >
    //               Reset
    //             </Button>
    //             <Button
    //               type="link"
    //               size="small"
    //               onClick={() => {
    //                 confirm({
    //                   closeDropdown: false,
    //                 });
    //                 setSearchText(selectedKeys[0]);
    //                 setSearchedColumn(dataIndex);
    //               }}
    //               className='button-color btn-header'
    //             >
    //               Filter
    //             </Button>
    //             <Button
    //               type="link"
    //               size="small"
    //               onClick={() => {
    //                 close();
    //               }}
    //               className='button-color btn-header'
    //             >
    //               Close
    //             </Button>
    //           </Space>
    //         </div>
    //       ),
    //       filterIcon: (filtered) => (
    //         <SearchOutlined
    //           style={{
    //             color: filtered ? "var(--sidebar-color)" : undefined,
    //           }}
    //         />
    //       ),
    //       onFilter: (value, record) =>
    //         record[dataIndex]
    //           ?.toString()
    //           .toLowerCase()
    //           .includes(value.toLowerCase()),
    //       onFilterDropdownOpenChange: (visible) => {
    //         if (visible) {
    //           setTimeout(() => searchInput.current?.select(), 100);
    //         }
    //       },
    //       render: (text) =>
    //         searchedColumn === dataIndex ? (
    //           <Highlighter
    //             highlightStyle={{
    //               backgroundColor: "var(--sidebar-color)",
    //               padding: 0,
    //             }}
    //             searchWords={[searchText]}
    //             autoEscape
    //             textToHighlight={text ? text.toString() : ""}
    //           />
    //         ) : (
    //           text
    //         ),
    //     };
    //   }
    // };
    
    const columns = tableHeaders?.map((header, index) => {
        let column = {
          title: header,
          dataIndex: headerSelector[index],
          key: headerSelector[index],
          // ...getColumnSearchProps(headerSelector[index]),
          sorter: (a, b) => {
            const valueA = a[headerSelector[index]];
            const valueB = b[headerSelector[index]];
      
            if (typeof valueA === "string" && typeof valueB === "string") {
              return valueA.localeCompare(valueB, undefined, {
                sensitivity: "base",
              });
            } else if (typeof valueA === "number" && typeof valueB === "number") {
              return valueA - valueB;
            } else if (valueA instanceof Date && valueB instanceof Date) {
              return valueA - valueB;
            } else {
              // One value is a string and the other is a number or date, prioritize string sorting
              return typeof valueA === "string" ? -1 : 1;
            }
          },
          sortDirections: ["descend", "ascend"],
        };    

        if (header === 'Status') {
          column.render = (status) => {
            let color = 'red';
      
            if(status === "occupied" || status === "pending" || status === "ongoing" || status === "due"){
                color = 'red'
            } else if(status === "vacant" || status === "active" || status === "paid" || status === "completed"){
                color = 'green'
            } else if(status === "for renewal"  || status === "closed"){
                color = 'blue'
            } else if(status === "moved out"){
                color = 'black'
            } else if(status === "pre-terminated"){
                color = 'orange'
            } else if(status === "voided"){
                color = 'grey'
            } else if(status === "open"){
                color = 'yellow'
            }
      
            return (
              <Tag color={color}>{status.toUpperCase()}</Tag>
            );
          };
        }
      
        return column;
      });
      
    if (withAction) {
      columns.push({
        // title: "ACTION",
        key: "action",
        width: 100,
        // color: "var(--sidebar-color)",
        render: (_, record) => <ActionBtn row={record} />,
      });
    }
  
    return (
      <Table
        columns={columns}
        dataSource={tableData}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        loading={{
          indicator: customSpinner, // Use custom spinner
          spinning: loading, // Set spinning based on loading state
        }}
        footer={customFooter}
        size="middle"
        className="table-bg"
        pagination={{
          defaultPageSize: 10,
          // showQuickJumper: true,
          // showSizeChanger: true,
          total: totalSize,
          current: filterConfig?.page,
          pageSize: filterConfig?.total_records_per_page,
        }}
        onChange={handleTableChange}
      />
    );
  };
  
  export default AntDTable;